import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "flex flex-1 items-center justify-end space-x-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Complete Purchase")

import AppButton from "@/components/app/AppButton.vue";
import AppPanel from "@/components/app/AppPanel.vue";
import InputNumber from "@/components/input/InputNumber.vue";
import AppPrice from "@/components/app/AppPrice.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MintStepPurchaseDetails',
  props: ["modelValue", "price"],
  emits: ["update:modelValue", "submit"],
  setup(__props, { emit }) {

const props = __props




const onClick = async function () {
    emit("submit", { quantity: props.modelValue, price: props.price });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppPanel, {
      color: "transparent",
      title: "Dripversity NFT",
      subtitle: "1:1 NFT",
      src: require('@/assets/images/placeholder.png')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InputNumber, {
            id: "mint-price",
            label: "Price",
            "model-value": __props.modelValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
            min: 1,
            max: 5
          }, null, 8, ["model-value"]),
          _createVNode(AppPrice, {
            price: __props.modelValue * __props.price,
            digits: 4,
            class: "w-16 items-end"
          }, null, 8, ["price"])
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createVNode(AppButton, {
      "full-width": "",
      size: "sm",
      onClick: _withModifiers(onClick, ["prevent"])
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}
}

})